import { createAction } from '@mendeley-internal/lib-js-redux-actions';
import api from '../services/api/request';

export const saveToLibrary = createAction(
  'SAVE_TO_LIBRARY',
  ({ doc }) => api.post('library', doc.id),
  ({
    doc,
    position,
    currentPage,
    isSuggested,
  }) => ({
    doc,
    position,
    currentPage,
    isSuggested,
  }),
);



// WEBPACK FOOTER //
// ./src/universal/ui/actions/library.js